import { render, staticRenderFns } from "./HomeFeedTripleMenu.vue?vue&type=template&id=530ab6c8&scoped=true"
import script from "./HomeFeedTripleMenu.vue?vue&type=script&lang=js"
export * from "./HomeFeedTripleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ab6c8",
  null
  
)

export default component.exports